var ButtonPushBounceIdleBubbleAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")
var UIProgressTimer = require("clover/panel/component/common/UIProgressTimer")

var FriendPvpActivityMatchPanel = xClass("FriendPvpActivityMatchPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/panel_pvpmatching_panel_matching.csb")
})

FriendPvpActivityMatchPanel.show = function (logic, onCloseCb, invitedParams, activityInfo) {
    // var Authorize = require('clover/utils/AuthorizePanel');
    // if (Authorize.hasInstance()){
    //     var authorizePanel = Authorize.getInstance();
    //     if (authorizePanel){
    //         authorizePanel.closePanelWithoutCallback();
    //     }
    // }

    var panel = FriendPvpActivityMatchPanel.create(logic, onCloseCb, invitedParams, activityInfo);
    return panel;
}

FriendPvpActivityMatchPanel.prototype.ctor = function (logic, onCloseCb, invitedParams, activityInfo) {
    var self = this;
    self.bannerAdName = BannerAdPanel.kNewPvp;
    self.bannerAdOffsetY = MetaManager.getInstance().canShowBannerAd(self.bannerAdName) ? 40 : 0;
    BasePanel.prototype.ctor.call(self);
    self.logic = logic;
    self.onCloseCb = onCloseCb;
    if (invitedParams){
        // 点分享进来的才会有这个参数
        self.logic.pvpManager.isInvitedPlayer = true;
        self.logic.pvpManager.isRobot = false;
        self.isInviteMode = true;
        self.isInvitedPlayer = true;
        self.invitedParams = invitedParams;
    }else{
        self.logic.pvpManager.isInvitedPlayer = false;
        self.logic.pvpManager.isRobot = false;
        self.isInvitedPlayer = false;
        self.invitedParams = null;
        self.startCheckMatchPlayerIsOutTask = null;
        if (activityInfo){
            self.activityInfo = activityInfo;
            self.isInviteMode = false;
        }else{
            self.isInviteMode = true;
        }
    }
    var glass = self.getChildByName("pvp").getChildByName("glass");
    glass.setVisible(false);
    var glass2 = self.getChildByName("pvp").getChildByName("glass_anim");
    var glassAnim = cc.CSLoader.createTimeline("cocos/panel_pvpmatching_glass1.csb");
    if (self.isInviteMode){
        self.logic.pvpManager.mode = 1;
        if (self.isInvitedPlayer){
            glass2.setVisible(false);
        }else{
            glass2.runAction(glassAnim);
        }
    }else{
        self.logic.pvpManager.mode = 2;
        glass2.runAction(glassAnim);
    }
    self.canStartGame = false; //发分享的人有人接受后可以开始
    CfgManager.load("friend_pvp")
    .then((data) => {
        var config = data.get("friend_pvp");
        self.inviteAgreeTime = config.pvp_invited_agree_time;
        self.matchWaitMaxTime = config.pvp_random_waittime/1000;
        self.matchDec = config.pvp_random_decisiontime || 3000;
        self.initUI();
        if (!self.isInviteMode){
            self.startMatchTask();
        }
        CfgManager.release("friend_pvp");
        self.popup();
    });

    cc.log("BannerAdPanel.kNewPvp", BannerAdPanel.kNewPvp);
    self.bannerAdName = BannerAdPanel.kNewPvp;
}

FriendPvpActivityMatchPanel.prototype.startMatchTask = function(){
    var self = this;
    self.clearMatchTask();
    self.clearCheckMatchPlayerTask();
    self.matchWaitTime = 0;
    self.nextMatchTime = 0;
    var startWaitTime = Localhost.time();
    var func = function(){
        self.matchWaitTime = Localhost.time()-startWaitTime;
        if (self.nextMatchTime == 0){
            self.nextMatchTime = 2500;
        }else if(self.matchWaitTime < self.nextMatchTime){
            return
        }
        cc.log("match wait:", self.matchWaitTime, new Date().getTime());
        var onSuccess = function(evt){
            var data = evt.data;
            if (data.status == -1){
                Toast.make(getText("error.tip.761316"));
                self.onCloseCb();
            }else if (data.status == 2 && data.roleType){
                self.getChildByName("num2").setVisible(false);
                self.getChildByName("txt2").setString(getText("pvp.match.text2"));

                cc.log("roleType:", data.roleType, "progress:", data.progress, "startCheckMatchPlayerIsOutTask:", self.startCheckMatchPlayerIsOutTask);
                // 匹配成功，房主先创建房间，之后房客加入房间
                if (data.roleType == 1){
                    self.getChildByName("btn_quit").setVisible(false);
                    self.clearMatchTask();
                    self.logic.pvpManager.isInvitedPlayer = false;
                    self.isInvitedPlayer = false;
                    self.requestCreateMatchRoom();
                    // 房主开始创建房间就开始倒计时房客是否不在线
                    self.waitCheckMatchPlayerIsOut();
                }else if (data.roleType == 2 && data.progress == 2){
                    // 房间已经创建好了等待加入
                    self.clearMatchTask();
                    var roomId = data.roomId;
                    self.logic.pvpManager.isInvitedPlayer = true;
                    self.logic.pvpManager.roomHost = data.targetUid
                    self.isInvitedPlayer = true;
                    self.requestJoinMatchRoom(roomId);
                }else if (data.roleType == 2 && data.progress == 1 && !self.startCheckMatchPlayerIsOutTask){
                    // 房客等待建房间开始倒计时房客是否不在线
                    self.waitCheckMatchPlayerIsOut();
                }
            }else if (data.status == 3 || data.status == 4){
                // 匹配机器人
                self.getChildByName("btn_quit").setVisible(false);
                self.getPvpRobot();
            }
        }
        var onFail = function(evt){
            cc.error(evt);
            Toast.make(getText("error.tip." + tostring(evt.data)));
            if (evt.data == 761313){
                self.onCloseCb(true);
            }else{
                self.onCloseCb();
            }
        }
        var http = FriendPvpMatchHttp.new();
        http.addEventListener(Events.kComplete, onSuccess);
        http.addEventListener(Events.kError, onFail);
        http.addEventListener(Events.kCancel, onFail);
        http.load(self.nextMatchTime);

        self.nextMatchTime += self.matchDec;
    }
    self.matchTask = setInterval(()=>{
        func();
    }, 200);
    func();
}

FriendPvpActivityMatchPanel.prototype.requestCreateMatchRoom = function(){
    var self = this;
    var userInfo = {"name": UserManager.getInstance().profile.name, "avatar": UserManager.getInstance().profile.headUrl};
    var onSuccess = function(){
        cc.log("----connect success, not create room success----");
    }
    var onFail = function(){
        Toast.make(getText("pvp.link.error"));
    }
    self.logic.pvpManager.createRoom(userInfo, onSuccess, onFail);
}

FriendPvpActivityMatchPanel.prototype.onCreateMatchRoom = function () {
    cc.log("onCreateMatchRoom");
    var self = this;
    self.roomInited = true;
}

FriendPvpActivityMatchPanel.prototype.waitCheckMatchPlayerIsOut = function () {
    cc.log("****waitCheckMatchPlayerIsOut****");
    var self = this;
    self.clearCheckMatchPlayerTask();
    self.startCheckMatchPlayerIsOutTime = Localhost.timeInSec()
    self.startCheckMatchPlayerIsOutTask = setInterval(()=>{
        var t = Localhost.timeInSec() - self.startCheckMatchPlayerIsOutTime;
        cc.log("check match player out:", t);
        if (t > 10){
            self.clearCheckMatchPlayerTask();
            self.logic.closedByServer = false;
            self.logic.closedByClient = true;
            var cb = function(){
                self.logic.pvpManager.clearEvent();
                self.logic.pvpManager.initSocket();

                var onSuccess = function(evt){
                    self.getPvpRobot();
                }
                var onFail = function(evt){
                    cc.error(evt);
                }
                var http = FriendPvpMatchCancelHttp.new();
                http.addEventListener(Events.kComplete, onSuccess);
                http.addEventListener(Events.kError, onFail);
                http.addEventListener(Events.kCancel, onFail);
                http.load();
            }
            self.logic.pvpManager.closeSocket(cb, cb);
        }
    }, 1000);
}

FriendPvpActivityMatchPanel.prototype.requestJoinMatchRoom = function (roomId) {
    var self = this;
    var userInfo = {"name": UserManager.getInstance().profile.name, "avatar": UserManager.getInstance().profile.headUrl};
    self.logic.pvpManager.joinRoom(roomId, userInfo);
    self.waitCheckMatchPlayerIsOut();
}

FriendPvpActivityMatchPanel.prototype.clearMatchTask = function(){
    cc.log("clearMatchTask");
    var self = this;
    if (self.matchTask){
        clearInterval(self.matchTask);
    }
    self.matchTask = null;
    
    self.cleanCheckNoStartGameAfter60s();
}

FriendPvpActivityMatchPanel.prototype.clearCheckMatchPlayerTask = function(){
    cc.log("clearCheckMatchPlayerTask");
    var self = this;
    if (self.startCheckMatchPlayerIsOutTask){
        clearInterval(self.startCheckMatchPlayerIsOutTask);
    }
    self.startCheckMatchPlayerIsOutTask = null;
}

FriendPvpActivityMatchPanel.prototype.initUI = function (matchData) {
    var self = this;
    self.acceptBtn = self.getChildByName("btn_green_accept");
    if (!self.isInvitedPlayer){
        self.acceptBtn.setVisible(false);
    }else{
        self.acceptBtn.getChildByName("label").x += 10;
    }
     
    // 昵称积分
    var pvpNode = self.getChildByName("pvp");
    //对方积分
    var num1Label = pvpNode.getChildByName("num1").getChildByName("num");
    num1Label.setFontStyle("bold");
    //自己积分
    var num2Label = pvpNode.getChildByName("num2").getChildByName("num");
    num2Label.setFontStyle("bold");
    //自己名字
    var blueName = pvpNode.getChildByName("num2").getChildByName("name");
    blueName.getVirtualRenderer().setDimensions(150, 0)
    blueName.setContentSize(blueName.getVirtualRendererSize())
    blueName.setFontStyle("bold");
    //对方名字
    var redName = pvpNode.getChildByName("num1").getChildByName("name");
    redName.getVirtualRenderer().setDimensions(150, 0)
    redName.setContentSize(redName.getVirtualRendererSize())
    redName.setFontStyle("bold");
    self.redName = redName;
    self.redScore = num1Label;
    //自己奖杯
    var trophy1 = pvpNode.getChildByName("icon_trophy1");
    //对方奖杯
    var trophy2 = pvpNode.getChildByName("icon_trophy2");

    // 头像
    var bluePhoto = self.getChildByName("pvp").getChildByName("frame_photo2").getChildByName("photo");
    bluePhoto.setAnchorPoint(cc.p(0.5, 0.5));
    bluePhoto.x += 50;
    bluePhoto.y -= 50;
    var redPhoto = self.getChildByName("pvp").getChildByName("frame_photo3").getChildByName("photo");
    redPhoto.setAnchorPoint(cc.p(0.5, 0.5));
    redPhoto.x += 50;
    redPhoto.y -= 50;
    self.redPhoto = redPhoto;

    UIUtils.fixTextWidth(blueName, UserManager.getInstance().profile.name, 150);
    HeadImageLoader.loadImage(bluePhoto, UserManager.getInstance().profile.headUrl);

    // 标题栏
    var txt = self.getChildByName("txt1");
    txt.y -= 70;
    txt.setFontStyle("bold");
    txt.setFontSize(35);

    // 等待是对方名字显示等待加入，积分是？？？
    if (self.isInviteMode){
        num1Label.setString("？？？");
        num2Label.setString(self.logic.pvpManager.activityInfo.totalScore);
        trophy1.y += 15;
        trophy2.y += 15;
        trophy2.x -= 4;

        if (self.isInvitedPlayer){
            UIUtils.fixTextWidth(redName, HeDisplayUtil.urlDecode(self.invitedParams.userName), 150);
            HeadImageLoader.loadImage(redPhoto, HeDisplayUtil.urlDecode(self.invitedParams.userAvatar));
        }else{
            redName.setString(getText("pvp.match.name01"));
        }

        if (self.isInvitedPlayer){
            // 被邀请的问价的标题吗，倒计时        
            self.getChildByName("num2").setVisible(false);
            self.getChildByName("txt2").setVisible(false);

            self.hasAcceptMatch = false;
            txt.setString(getText("pvp.invited.agree.text1"));
            var secondTxt = self.getChildByName("second1");
            secondTxt.setString(5);
            secondTxt.y -= 92;
            secondTxt.x += 20;
            secondTxt.getVirtualRenderer().setAlignment(cc.TEXT_ALIGNMENT_CENTER);
            secondTxt.setAnchorPoint(cc.p(0.5, 0.5));
            var curSec = self.inviteAgreeTime;
            secondTxt.setString(curSec);
            // 5秒后自动接收邀请
            var autoAccept = function(){
                self.sendJoinRoom();
            }
            var refreshSecondTxt = function(){
                curSec -= 1;
                secondTxt.setString(curSec);
                if (curSec <= 1){
                    self.getChildByName("btn_quit").setVisible(false);
                }
                if (curSec <= 0){
                    self.acceptBtn.stopAllActions();
                    autoAccept();
                }
            }
            self.acceptBtn.runAction(cc.repeatForever(cc.sequence(cc.delayTime(1), cc.callFunc(refreshSecondTxt))));
        }else{
            self.getChildByName("second1").setVisible(false);
            self.getChildByName("num2").setVisible(false);
            self.getChildByName("txt2").setVisible(false);
            txt.setString(getText("pvp.invited.text1"));
        }

        self.getChildByName("btn_quit").getChildByName("txt").setString(getText("pvp.invited.quit"));
        self.getChildByName("btn_quit").getChildByName("line").setScaleX(1);
        self.getChildByName("btn_quit").x -= 10;
        self.getChildByName("btn_quit").y += 50;
    }else{
        num1Label.setString("???");
        num2Label.setString(self.activityInfo.totalScore);
        trophy1.y += 15;
        trophy2.y += 15;
        trophy2.x -= 4;

        redName.setString(getText("pvp.match.name01"));

        // 标题倒计时
        self.getChildByName("second1").setVisible(false);
        self.getChildByName("txt1").setVisible(false);
        var secondTxt = self.getChildByName("num2");
        secondTxt.setAnchorPoint(cc.p(0.5, 0.5));
        secondTxt.getVirtualRenderer().setAlignment(cc.TEXT_ALIGNMENT_CENTER);
        secondTxt.setString(self.matchWaitMaxTime);
        secondTxt.y += 26;
        secondTxt.x += 93;

        var second = self.matchWaitMaxTime;
        var refreshSecond = function(){
            second -= 1;
            if (second < 0){
                secondTxt.stopAllActions();
                return;
            }
            secondTxt.setString(second);
        }
        secondTxt.runAction(cc.repeatForever(cc.sequence(cc.delayTime(1), cc.callFunc(refreshSecond))));

        self.getChildByName("btn_quit").getChildByName("txt").setString(getText("pvp.match.quit"));
        self.getChildByName("btn_quit").getChildByName("line").setScaleX(1);
        self.getChildByName("btn_quit").x -= 10;
        self.getChildByName("btn_quit").y += 50;
    }

    self.pvpAction = cc.CSLoader.createTimeline("cocos/panel_pvpmatching_pvp.csb");
    pvpNode.runAction(self.pvpAction);

    var time = Localhost.timeInSec();
    quickBuildUIBUtton(self.getChildByName("btn_quit"), () => {
        var t = Localhost.timeInSec();
        if (self.isInviteMode){
            DCAssist.userTrack("PVP", "click_quit_invite_btn", {"abtest":"new", "type":"friend", "s_time":(t - time)});
            self.logic.closedByClient = true;
            if (self.isInvitedPlayer){
                if (self.hasAcceptMatch){
                    self.logic.pvpManager.leaveRoom();
                }else{
                    // 被邀请的人还没接收邀请时还没加入房间所以不需要leaveRoom
                }
            }else{
                self.logic.pvpManager.leaveRoom();
            }
            self.onCloseCb();
        }else{
            DCAssist.userTrack("PVP", "click_quit_invite_btn", {"abtest":"new", "type":"random", "s_time":(t - time)});
            var onSuccess = function(evt){
                if (evt.data.status == 2){
                    self.startMatchTask();
                }else{
                    self.logic.pvpManager.clearEvent()
                    self.logic.pvpManager.initSocket()
                    self.onCloseCb();
                }
                self.clearMatchTask();
            }
            var onFail = function(evt){
                cc.error(evt);
            }
            var http = FriendPvpMatchCancelHttp.new();
            http.addEventListener(Events.kComplete, onSuccess);
            http.addEventListener(Events.kError, onFail);
            http.addEventListener(Events.kCancel, onFail);
            http.load();
        }
    })

    quickBuildUIBUtton(self.getChildByName("btn_green_accept"), () => {
        cc.log("self.isInvitedPlayer", self.isInvitedPlayer)
        cc.log("self.canStartGame", self.canStartGame)
        if (self.isInvitedPlayer){
            //点分享的人有人接受邀请
            self.sendJoinRoom();
        }else{
            if (self.canStartGame){
                //发分享的人有人接受后可以开始
                self.startGame();
            }
        }
    })

    // if (__DEBUG){
    //     self.isInvitedPlayer = false;
    //     self.logic.pvpManager.you = {name:"1111"};
    //     self.onJoinRoom();
    // }
}

FriendPvpActivityMatchPanel.prototype.sendJoinRoom = function(){
    var self = this;
    var userInfo = {"name": UserManager.getInstance().profile.name, "avatar": UserManager.getInstance().profile.headUrl};
    self.logic.pvpManager.joinRoom(self.invitedParams.roomid, userInfo);
    
    DCAssist.userTrack("PVP", "click_pk_btn", {"abtest":"new", "type":"friend", "info": self.logic.pvpManager.id});


    self.acceptBtn.stopAllActions();
    self.acceptBtn.setVisible(false);
}

FriendPvpActivityMatchPanel.prototype.showAcceptMatchUI = function () {
    let self = this
    if (self.hasAcceptMatch == false){
        self.getChildByName("second1").setVisible(false);
        self.getChildByName("txt1").setString(getText("pvp.invited.agree.text2"));
        self.acceptBtn.setVisible(false);
        self.pvpAction.gotoFrameAndPlay(0, 53, 0, false);
        self.hasAcceptMatch = true;
        self.getChildByName("btn_quit").setVisible(true);
    }
}

FriendPvpActivityMatchPanel.prototype.onJoinRoom = function (evt) {
    let self = this
    self.getChildByName("pvp").getChildByName("glass_anim").setVisible(false);
    if (self.isInviteMode){
        if (self.isInvitedPlayer){
            self.showAcceptMatchUI();
            self.redScore.setString(evt.data.targetScore);
            // 接受邀请后60秒不开始会被服务器断开
            self.startCheckNoStartGameAfter60s();
        }else{
            // 发分享的人只有点分享人点接受邀请才会看到对手信息
            self.pvpAction.gotoFrameAndPlay(0, 53, 0, false);
            let enemyInfo = self.logic.pvpManager.you
            cc.log("enemyInfo", enemyInfo)
            UIUtils.fixTextWidth(self.redName, enemyInfo.name, 180);
            self.redScore.setString(evt.data.targetScore);
            HeadImageLoader.loadImage(self.redPhoto, enemyInfo.avatar);
            self.acceptBtn.setVisible(true);
            self.acceptBtn.getChildByName("label").setString(getText("pvp.start.button"));
            self.acceptBtn.getChildByName("label").x += 5;
            var txt = self.getChildByName("txt1");
            txt.setString(getText("pvp.invited.text2"));
            self.getChildByName("btn_quit").setVisible(false);
            self.canStartGame = true;
            self.logic.pvpManager.setPvpMode(1);
            // 接受邀请后60秒不开始会被服务器断开
            self.startCheckNoStartGameAfter60s();
        }
    }else{
        self.logic.pvpManager.setPvpMode(2);
        self.pvpAction.gotoFrameAndPlay(0, 53, 0, false);
        self.pvpAction.setLastFrameCallFunc(() => {
            if (!self.isInvitedPlayer || self.logic.pvpManager.isRobot) {
                self.startGame();
            } else {
                // 匹配房客方打点
                DCAssist.userTrack("PVP", "click_pk_btn", {"abtest":"new", "s_time":self.matchWaitTime, "type":"random", "info": self.logic.pvpManager.id});
            }
        })
        let enemyInfo = self.logic.pvpManager.you
        cc.log("enemyInfo", enemyInfo);
        UIUtils.fixTextWidth(self.redName, enemyInfo.name, 180);
        self.redScore.setString(evt.data.targetScore);
        HeadImageLoader.loadImage(self.redPhoto, enemyInfo.avatar);
        self.getChildByName("btn_quit").setVisible(false);
    }
}

FriendPvpActivityMatchPanel.prototype.startCheckNoStartGameAfter60s = function(){
    var self = this;
    self.checkNoStartGame = setTimeout(()=>{
        self.cleanCheckNoStartGameAfter60s();
        self.onCloseCb(null, true);
    }, 65000);
}

FriendPvpActivityMatchPanel.prototype.cleanCheckNoStartGameAfter60s = function(){
    var self = this;
    if (self.checkNoStartGame){
        clearTimeout(self.checkNoStartGame);
        self.checkNoStartGame = null;
    }
}

FriendPvpActivityMatchPanel.prototype.getPvpRobot = function(){
    var self = this;
    self.clearMatchTask();
    self.clearCheckMatchPlayerTask();
    self.logic.pvpManager.isRobot = true;
    var onSuccess = function(evt){
        var you = {};
        you.robotUid = evt.data.robotUid;
        you.levelId = evt.data.levelId;
        you.name = HeDisplayUtil.urlDecode(evt.data.nickname);
        you.avatar = evt.data.avatar;
        you.score = evt.data.score;
        you.time = evt.data.time;
        you.robotScore = evt.data.robotScore;
        self.logic.pvpManager.you = you;
        var evt2 = {data:{targetScore:evt.data.robotScore}};
        self.onJoinRoom(evt2);
    }
    var onFail = function(evt){
        cc.error(evt);
    }
    var http = FriendPvpRobotHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);
    http.load();
}

FriendPvpActivityMatchPanel.prototype.startGame = function () {
    var self = this
    if (self.isBusy) {
        return
    }
    if (self.isInviteMode){
        DCAssist.userTrack("PVP", "click_pk_btn", {"abtest":"new", "type":"friend", "info": self.logic.pvpManager.id});
    }else{
        DCAssist.userTrack("PVP", "click_pk_btn", {"abtest":"new", "s_time":self.matchWaitTime, "type":"random","info": self.logic.pvpManager.id});
    }
    self.isBusy = true;
    self.logic.pvpManager.startGame();
    self.acceptBtn.setEnabled(false);
    self.isBusy = false;
}

FriendPvpActivityMatchPanel.prototype.handleRoomFulled = function(){
    let self = this;
    Toast.make(getText("pvp.help.failed06"));
    self.logic.closedByClient = true;
    self.logic.pvpManager.leaveRoom();
    self.onCloseCb();
}

FriendPvpActivityMatchPanel.prototype.handleNoRoom = function () {
    let self = this;
    Toast.make(getText("pvp.help.failed06"));
    self.logic.closedByClient = true;
    self.logic.pvpManager.leaveRoom();
    self.onCloseCb();
}

FriendPvpActivityMatchPanel.prototype.handleFriendPvpNoBeHelpTimes = function () {
    let self = this;
    Toast.make(getText("pvp.help.failed01"));
    self.logic.closedByClient = true;
    self.logic.pvpManager.leaveRoom();
    self.onCloseCb();
}

FriendPvpActivityMatchPanel.prototype.handleFriendPvpNoTicket = function () {
    let self = this;
    Toast.make(getText("pvp.help.failed02"));
    self.logic.closedByClient = true;
    self.logic.pvpManager.leaveRoom();
    self.onCloseCb();
}

FriendPvpActivityMatchPanel.prototype.handleFriendPvpEnemyOffline = function () {
    let self = this;
    Toast.make(getText("pvp.friends.battlefailed"));
    self.logic.closedByClient = true;
    self.logic.pvpManager.leaveRoom();
    self.onCloseCb();
}

FriendPvpActivityMatchPanel.prototype.handleFriendPvpNoHelpTimes = function () {
    let self = this;
    Toast.make(getText("error.tip.761308"));
    self.logic.closedByClient = true;
    self.logic.pvpManager.leaveRoom();
    self.onCloseCb(false, true);
}

FriendPvpActivityMatchPanel.prototype.popup = function () {
    var self = this
    PopoutManager.getInstance().addWithBgFadeIn(self, true, false)
    var dH = display.height-GamePlayConfig_Design_Height;
    targetPos = cc.p(-40, 1000 + dH/2);
    self.setScale(1)
    self.setPosition(targetPos);
    self.tryShowBannerAd();
    return self
}

FriendPvpActivityMatchPanel.prototype.onCleanup = function() {
    ResManager.release(["packed/PvpMatchRes.pack"]);
}

module.exports = FriendPvpActivityMatchPanel